import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { SubscriptionPlanEnum } from '@therapist/shared/models/subscription/subscription-plan.enum';
import { CheckoutResponseDto, SubscriptionOverviewDto } from '@therapist/shared/models/subscription/subscription-overview.dto';

@Injectable({ providedIn: 'root' })
export class SubscriptionApiService {

  readonly #http = inject(HttpClient);

  private get endpoint() {
    return `${environment.basePath}/subscription`;
  }

  getOverview(): Observable<SubscriptionOverviewDto> {
    return this.#http.get<SubscriptionOverviewDto>(`${this.endpoint}`);
  }

  createCheckout(plan: SubscriptionPlanEnum): Observable<CheckoutResponseDto> {
    return this.#http.post<CheckoutResponseDto>(`${this.endpoint}/checkout`, { plan: plan });
  }

  confirmCheckout(sessionId: string): Observable<SubscriptionOverviewDto> {
    return this.#http.post<SubscriptionOverviewDto>(`${this.endpoint}/checkout/confirm`, { sessionId: sessionId });
  }
}
